import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { selectV2Theme } from "../selectV2Theme";

interface SelectedValueWrapperProps {
    isContentBeforeVisible: boolean;
    themeMode: RequiredThemeKeys;
}

export const SelectedValueWrapper = styled("div")<SelectedValueWrapperProps>`
    position: absolute;

    // very specifically match the position of the input.
    left: ${({ isContentBeforeVisible, themeMode }) =>
        isContentBeforeVisible
            ? selectV2Theme.input.padding.placeholder(themeMode)
            : selectV2Theme.input.padding.left(themeMode)};

    // Allow the text to clip properly.
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    // Give the formatted stuff the space it needs to breathe.
    display: flex;
    align-items: center;
    height: 100%;
`;
